export function isQuickWin(decision) {
  return Boolean(decision && (decision.quick_win || decision.is_quick_win));
}

export function visibleDecisions(decisions, filter) {
  const rows = decisions || [];
  if (filter === 'quick_wins') {
    return rows.filter((decision) => isQuickWin(decision));
  }
  return rows;
}
